// extracted by css-extract-rspack-plugin
export default {"grammarErrorAlert__container":"grammarErrorAlert__container__WI1XQ","grammarErrorAlert__title":"grammarErrorAlert__title__RjwZZ"};